import { render, staticRenderFns } from "./DichVuVeDienTuList.vue?vue&type=template&id=33c63e0d"
import script from "./DichVuVeDienTuList.vue?vue&type=script&lang=js"
export * from "./DichVuVeDienTuList.vue?vue&type=script&lang=js"
import style0 from "./DichVuVeDienTuList.vue?vue&type=style&index=0&id=33c63e0d&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports